import { breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import { useProperty } from '@eti/providers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sizeStyles = css`
  flex-shrink: 0;
  height: 20px;
  width: 20px;

  @media (min-width: ${breakpoints._768}) {
    height: 32px;
    width: 32px;
  }

  @media (min-width: ${breakpoints._970}) {
    height: 40px;
    width: 40px;
  }
`;
const CarrierLogo = ({
  'aria-hidden': ariaHidden,
  className = sizeStyles,
  'data-testid': dataTestId,
  imageAlt,
  logo
}) => {
  const {
    p
  } = useProperty();
  const isDarkModeEnabled = p('CustomerWeb.UseDarkModeTheme.Enabled');
  if (!logo) {
    return null;
  }
  const lightModeSrcSet = `${logo.small} 1x,${logo.large} 2x`;
  const darkModeSrcSet = `${logo.darkModeSmall} 1x,${logo.darkModeLarge} 2x`;
  return /*#__PURE__*/_jsxs("picture", {
    children: [isDarkModeEnabled && /*#__PURE__*/_jsx("source", {
      media: "(prefers-color-scheme: dark)",
      srcSet: darkModeSrcSet
    }), /*#__PURE__*/_jsx("source", {
      media: "(prefers-color-scheme: light)",
      srcSet: lightModeSrcSet
    }), /*#__PURE__*/_jsx("img", {
      alt: imageAlt,
      "aria-hidden": ariaHidden,
      className: className,
      "data-testid": dataTestId,
      src: logo.small,
      srcSet: lightModeSrcSet
    })]
  });
};
export default CarrierLogo;
//# sourceMappingURL=CarrierLogo.js.map